// frontend/client/src/context/ChatbaseContext.js

import React, { createContext, useContext, useState, useCallback } from 'react';

// ✅ Export the context so class components can use it
export const ChatbaseContext = createContext({
  isChatbaseAvailable: true,
  disableChatbase: () => {},
});

// Hook for functional components
export const useChatbase = () => useContext(ChatbaseContext);

// Provider component
export const ChatbaseProvider = ({ children }) => {
  const [isChatbaseAvailable, setIsChatbaseAvailable] = useState(true);

  const disableChatbase = useCallback(() => {
    console.error("⚠️ Chatbase system permanently disabled due to critical failure.");
    setIsChatbaseAvailable(false);
  }, []);

  const value = { isChatbaseAvailable, disableChatbase };

  return (
    <ChatbaseContext.Provider value={value}>
      {children}
    </ChatbaseContext.Provider>
  );
};